import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"ml-8 mt-4",attrs:{"max-width":"280","color":"transparent"}},[_c(VSelect,{attrs:{"items":_vm.sortItems,"item-text":"text","item-value":"key","dense":"","label":_vm.selectedTitle},on:{"change":_vm.changeSortOrderItem},model:{value:(_vm.selectedSortItem),callback:function ($$v) {_vm.selectedSortItem=$$v},expression:"selectedSortItem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }